import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { useAppTranslation } from "../../hooks/useAppTranslation";

type Props = {
  open: boolean;
  documents: { documentNo?: string }[];
  onClose: () => void;
};

export default function PaymentValidationDialog({
  open,
  documents,
  onClose,
}: Props) {
  const { t } = useAppTranslation("common");

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t("Nie można wygenerować pliku")}</DialogTitle>

      <DialogContent dividers>
        <Typography sx={{ mb: 2 }}>
          {t("Następujące dokumenty nie mają wymaganych danych bankowych:")}
        </Typography>

        <List dense>
          {documents.map((d, i) => (
            <ListItem key={i}>
              <ListItemText
                primary={d.documentNo || t("(brak numeru dokumentu)")}
              />
            </ListItem>
          ))}
        </List>

        <Typography variant="caption" color="text.secondary">
          {t("Uzupełnij dane w Business Central i spróbuj ponownie.")}
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="contained">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}
